var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"badge",class:( _obj = {}, _obj[("badge_" + _vm.color)] = true, _obj.badge_bordered = _vm.bordered, _obj.badge_muted = _vm.muted, _obj.badge_rounded = _vm.rounded, _obj.badge_contrast = _vm.contrast, _obj )},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }